<template>
  <right-structure :Pdatas='infoData'>
  </right-structure>
</template>

<script>
  import structure from "@/components/flowStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: null,
        responseCode: null,
        infoData: {
          flowDesc: ['预存款-无感支付的大概流程为：',
            {
              preData: "1、下发预存款：第三方接收到车辆进场上报后，对该车牌进行判断是否已开通无感支付，若已开通则调用",
              link:  "下发预存款",
              url: "setPrestore",
              endData: "，对该车辆下发车辆预存款，用于离场时校验；"
            },
            '2、离场：车辆离场时，停车场系统回对车辆进行是否自动扣费校验，若车辆有预存款且为先离场后扣费，则会先开启道闸放行，并通过（临停缴费上报）上报车辆账单给第三方系统进行扣费；若车辆有预存款且为先扣费后离场，' +
            '则会通过（通知第三方缴费（先扣后离））接口通知第三方系统进行扣费，并且第三方系统需在8秒内返回扣费结果信息'
            ],
          flow: [
            {
              name: '先离场后扣费',
              desc: [
                '预存款-先离场后扣费的对接流程大概为：',
                [
                  {
                    preData: "1、下发预存款：第三方接收到车辆",
                    link:  "进场上报",
                    url: "reportCarIn",
                    endData: " 后，对该车牌进行判断是否已开通无感支付，若已开通则调用"
                  },
                  {
                    preData: "",
                    link:  "下发预存款",
                    url: "setPrestore",
                    endData: "，对该车辆下发车辆预存款，用于离场时校验；"
                  }
                ],
                {
                  preData: "2、离场：车辆离场时，停车场系统对车辆进行是否自动扣费校验，若车辆有预存款则会先开启道闸放行，第三方系统通过对接",
                  link:  "临停缴费上报",
                  url: "reportParkingFee",
                  endData: " 接收账单信息后判断是否为己方下发的预存款，进而进行扣费，其中platformShouldPay为应扣款金额。"
                }
              ],
              url: '/static/img/unconscious_pay_after_leaving.svg'
            },
            {
              name: '先扣费后离场',
              desc: [
                '预存款-先扣费后离场的对接流程大概为：',
                [
                  {
                    preData: "1、下发预存款：第三方接收到车辆",
                    link:  "进场上报",
                    url: "reportCarIn",
                    endData: " 后，对该车牌进行判断是否已开通无感支付，若已开通则调用"
                  },
                  {
                    preData: "",
                    link:  "下发预存款",
                    url: "setPrestore",
                    endData: "，对该车辆下发车辆预存款，用于离场时校验；"
                  }
                ],
                {
                  preData: "2、离场：车辆离场时，停车场系统对车辆进行是否自动扣费校验，若车辆有预存款则停车场系统会主动发起支付，此时第三方系统需通过接入",
                  link:  "通知第三方缴费（先扣后离）",
                  url: "reducePrestore",
                  endData: " 接收缴费信息进行扣费。",
                  warning: '请务必在 8 秒内响应扣费结果，否则将无法完成无感支付流程'
                },
              ],
              url: '/static/img/unconscious_pay_before_leaving.svg'
            },
            // {name: '先扣费后离场', url: '/static/img/unconscious_pay_before_leaving.svg'},
          ],
        }
      }
    },
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/trade/setPrestoreFlow.vue